import { Radio, Row, Form } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_expeditedstatus_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const EXPEDITEDSTATUS = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.expeditedstatus_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_expeditedstatus_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
    >
      <Form.Item name="EXPEDITED" label="EXPEDITED">
        <Radio.Group>
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
        </Radio.Group>
      </Form.Item>

      <Row>
        <label>VERIFY CODED CORRECTLY (Case Summary, FA Program Block)</label>
      </Row>
    </Form>
  );
});
export default EXPEDITEDSTATUS;
